module.exports = __webpack_public_path__ + "static/media/cafe_2.337b105e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/RestaurantAndCafe/images/cafe_2.jpg
// module id = 360
// module chunks = 0